import {
    INIT_SOCKET_HANDLER,
    SET_SOCKET_CONNECTION_COUNTER,
    SET_SOCKET_CONTEXT,
    SET_WINDOW_VISIBLE,
} from './types';

export const initSocketHandler = socket => dispatch => {
    dispatch({
        type: INIT_SOCKET_HANDLER,
        payload: socket,
    });
};

export const isWindowVisible = state => dispatch => {
    dispatch({
        type: SET_WINDOW_VISIBLE,
        payload: state,
    });
};

export const setSocketContext = context => ({
    type: SET_SOCKET_CONTEXT,
    payload: context,
});

export const setSocketConnectionCounter = counter => ({
    type: SET_SOCKET_CONNECTION_COUNTER,
    payload: counter,
});
